import {Dialog, Transition} from "@headlessui/react";
import {BlackButton} from "../../Buttons/BlackButton";
import {Fragment} from "react";
import {PrimaryButton} from "../../Buttons/PrimaryButton";
import {useTranslation} from "react-i18next";

export const ConfirmActionDialog = (props) => {
    const {
        open,
        onClose,
        onConfirm,
        title: titleProp,
        message: messageProp,
        subMessage: subMessageProp,
        loading = false
    } = props;

    const {t} = useTranslation();
    const title = titleProp ?? t('dialogs.confirm.default_title');
    const message = messageProp ?? t('dialogs.confirm.default_message');
    const subMessage = subMessageProp ?? t('dialogs.confirm.cannot_undo');

    return (
        <>
            <Transition appear show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={onClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/50"/>
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel
                                    className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900"
                                    >
                                        {title}
                                    </Dialog.Title>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">
                                            {message}
                                            {subMessage && <><br/>{subMessage}</>}
                                        </p>
                                    </div>

                                    <div className={'flex justify-end'}>
                                        <div className="mt-4 grid grid-cols-2 w-fit gap-4">
                                            <div>
                                                <BlackButton outlined={true} onClick={onClose} disabled={loading}>{t('general.actions.cancel')}</BlackButton>
                                            </div>
                                            <PrimaryButton onClick={onConfirm} disabled={loading}>
                                                {loading ? (
                                                    <div className="flex items-center">
                                                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                        </svg>
                                                        {t('general.actions.confirm')}...
                                                    </div>
                                                ) : t('general.actions.confirm')}
                                            </PrimaryButton>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}